import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {DialogActionsEnum, DialogComponent, DialogConfigInterface} from 'appShared/components';
import {FormInterface, PermissionRuleInterface} from 'appShared/interfaces';
import {Subscription} from 'rxjs';
import {BrokerForm} from 'appEntries/panel/forms/order-routes/broker.form';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {
    ApiError,
    ApiResponse,
    BrokerGetOutputModel,
    HttpStatusCodesEnum,
    OrderRouteService,
    ServerResponseData
} from '@spa/api';
import {Router} from '@angular/router';
import {AlertsService} from 'appShared/services';
import {PermissionRulesTrait} from 'appEntries/panel/traits';
import {AlertTypesEnum, PermissionRuleCheckStrategiesEnum} from 'appShared/enums';
import {FormComponent} from 'appShared/widgets';
import {PanelOrderRoutesMessages} from 'appAssets/messages';
import {OrderRoutesFormErrorStatesEnum} from 'appEntries/panel/enums';

@Component({
    selector: 'app-add-broker',
    templateUrl: './add-broker.component.html',
    styleUrls: ['./add-broker.component.scss']
})
export class AddBrokerComponent extends DialogComponent<AddBrokerComponent> implements FormInterface, OnDestroy, OnInit {

    protected subscriptions: Subscription[];
    public permissionRule: PermissionRuleInterface;
    public form: BrokerForm;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            config: DialogConfigInterface
        },
        protected router: Router,
        protected alertsService: AlertsService,
        protected orderRouteService: OrderRouteService,
        public dialogRef: MatDialogRef<AddBrokerComponent>,
    ) {
        super(dialogRef);
        this.subscriptions = [];
        this.permissionRule = PermissionRulesTrait.getOrderRoutesCreatePermissionRule(PermissionRuleCheckStrategiesEnum.Union);
        this.config = data.config;
    }

    handleErrorResponse(response: ApiResponse<ApiError[] | BrokerGetOutputModel>, error: ApiError): string {
        if (Array.isArray(response.messages) && response.messages[0]) {
            return response.messages[0];
        }

        return this.getErrorMessageByApiError(error);
    }

    onFormSubmit(action?: number): void {
        if (action !== DialogActionsEnum.Confirm) {
            this.dialogRef.close(false);

            return;
        }

        if (this.validateForm()) {
            const requestSubscription = this.form.createRequest()
                .subscribe((response: ServerResponseData<BrokerGetOutputModel>) => {
                    if (response.status !== HttpStatusCodesEnum.Ok) {
                        (response.data as ApiError[]).map((error: ApiError) => this.handleErrorResponse(response, error))
                            .filter((errorMessage: string) => {
                                return errorMessage.trim();
                            }).forEach((errorMessage: string) => {
                            this.alertsService.addAlert(errorMessage);
                        });

                        return;
                    }
                    this.alertsService.addAlert(this.getSuccessFormMessage(), AlertTypesEnum.Success);

                    this.dialogRef.close(true);
                });
            this.subscriptions.push(requestSubscription);
        }
    }

    getFormMessages(controlLabel?: string): { [p: string]: string } {
        return FormComponent.getFormMessages(controlLabel);
    }

    validateForm(): boolean {
        return this.form.validateForm(this.getFormMessages);
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach((subscription: Subscription) => subscription && subscription.unsubscribe());
    }

    ngOnInit(): void {
        this.initForm();
    }

    initForm(): void {
        this.form = new BrokerForm(this.orderRouteService);
        this.form.initForm();
    }

    getSuccessFormMessage(): string {
        return PanelOrderRoutesMessages.BrokerCreationSucceed.message;
    }

    getErrorMessageByApiError(error: ApiError): string {
        if (error.status === OrderRoutesFormErrorStatesEnum.CreateBrokersFailed) {
            return PanelOrderRoutesMessages.BrokerCreationFailed.message;
        }

        return PanelOrderRoutesMessages.UnknownError.message;
    }
}
